module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_ShouShou.0068.png.d6e6de8f.jpg";